<template>
    <div class="w-full px-3 mt-3 mb-6 text-left">
        <label
            class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
            >{{ label }}</label
        >
        <div class="w-full sm:mt-0 sm:col-span-2">
            <div class="relative rounded-md">
                <input
                    v-if="!isCurrency"
                    :value="value"
                    v-on="listeners"
                    @input="updateValue"
                    :placeholder="placeholder"
                    type="number"
                    min="0"
                    :max="max"
                    class="block w-40 h-8 px-2 text-gray-600 placeholder-gray-800 transition duration-150 ease-in-out border-b-2 border-gray-500 outline-none sm:text-base sm:leading-5"
                    :class="[hasError ? errorClass : activeClass, Addclass]"
                />
                <!-- :placeholder="placeholder" -->
                <vue-numeric
                    v-else
                    :currency="currency"
                    currency-symbol-position="suffix"
                    v-bind:precision="2"
                    separator="space"
                    :value="value === null ? 0 : value"
                    v-on="listeners"
                    v-on:input="updateValue"
                    @input="updateValue"
                    :min="0"
                    :max="max"
                    class="block w-40 h-8 px-2 text-gray-600 placeholder-gray-800 transition duration-150 ease-in-out border-b-2 border-gray-500 outline-none sm:text-base sm:leading-5"
                    :class="[hasError ? errorClass : activeClass, Addclass]"
                ></vue-numeric>

                <div
                    class="absolute inset-y-0 flex items-center pr-3 pointer-events-none ml-28"
                    v-if="hasError"
                >
                    <svg
                        class="w-5 h-5 text-red-500"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clip-rule="evenodd"
                        />
                    </svg>
                </div>
            </div>
            <p v-if="hasError" class="mt-2 text-sm text-red-600">
                {{ errorMessage }}
            </p>
        </div>
    </div>
</template>

<script>
import VueNumeric from "vue-numeric";

export default {
    components: { VueNumeric },
    inheritAttrs: false,
    props: {
        label: {
            type: String
        },
        Addclass: {
            type: String
        },
        placeholder: {
            type: String,
            default: "0"
        },
        value: {
            type: Number
        },
        max: {
            type: Number,
            default: 999999999999999999999
        },
        hasError: {
            type: Boolean,
            default: false
        },
        isCurrency: {
            type: Boolean,
            default: false
        },
        errorMessage: {
            type: String
        },
        currency: {
            type: String,
            default: "DH"
        }
    },
    computed: {
        listeners() {
            return {
                ...this.$listeners,
                input: this.updateValue
            };
        }
    },
    methods: {
        updateValue(event) {
            if (this.isCurrency) {
                if (!(this.value === null && event === 0))
                    this.$emit("input", parseFloat(event));
            } else {
                this.$emit("input", parseFloat(event.target.value));
            }
        }
    },
    data() {
        return {
            errorClass:
                " border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red ",
            activeClass: "border-gray-500"
        };
    }
};
</script>

<style></style>
